import { render } from "./DonationGroupListForm.vue?vue&type=template&id=1b6c6801"
import script from "./DonationGroupListForm.vue?vue&type=script&lang=js"
export * from "./DonationGroupListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__